import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-game-lock',
  templateUrl: './game-lock.component.html',
  styleUrls: ['./game-lock.component.scss']
})
export class GameLockComponent {

  public lock:any = {}
  private player_uuid:any;

  @Input() set setUserUUID(v:any) {
    this.player_uuid = v;
    this.init(v)
  }
  @Output() closeEvent = new EventEmitter();
  constructor(private http: HttpService, private route: ActivatedRoute) { 
    const uuid: Observable<string> = this.route.params.pipe(map(p => p['uuid']));
    
    uuid.subscribe(val => {
      if(val) {
        this.init(val)
      }
    })
  }

  async init(player_uuid:any) {
    let y = await this.http.post("/admin/player/active-game-lock", {player_uuid})
    this.lock = y;
  }

  close() {
    this.closeEvent.emit(true)
  }

  async withdrawExit() {
    let y = await this.http.post("/admin/player/withdraw-game-lock", this.lock)
    console.log(y)

    await this.init(this.player_uuid);
  }
}
